import { Box, Card, CardContent, Typography } from "@mui/joy";
import { DataGrid } from "../../../../components";
import { GfCActualValue, GfCMeasurementType } from "../GridFrameworkComponents";

const columnDefinitions = [
    { field: "name", headerName: "Measurement", flex: 1, cellRenderer: GfCMeasurementType },
    {
        field: "total",
        headerName: "Calculated",
        valueFormatter: (params: any) => {
            const value = Number(params.value) || 0;
            return `${value} ${params.data.unit}`;
        },
    },
    {
        field: "actual",
        headerName: "Actual",
        cellRenderer: GfCActualValue,
        cellStyle: { padding: 0 },
    },
    {
        field: "id",
        headerName: "Difference",
        valueGetter: (params: any) => {
            const total = Number(params.data.total) || 0;
            const actual = Number(params.data.actual) || 0;
            return total - actual;
        },
        valueFormatter: (params: any) => {
            const value = Number(params.value) || 0;
            return `${value} ${params.data.unit}`;
        },
        cellClassRules: {
            "diff-positive": (params: any) => params.value > 0,
            "diff-negative": (params: any) => params.value < 0,
            "diff-zero": (params: any) => params.value === 0,
        },
    },
];

export function DesktopView(props: { data: any; handleEdit: any }) {
    const { data, handleEdit } = props;

    return (
        <Box sx={{ width: "100%", overflow: "auto", mt: 1 }}>
            <Typography sx={{ fontWeight: 500, mb: 1 }} level="body-sm" gutterBottom>
                Roof Measurements
            </Typography>
            <Card sx={{ p: 0, overflow: "hidden" }}>
                <CardContent>
                    <DataGrid
                        gridData={data}
                        columnDefs={columnDefinitions}
                        autoHeight={true}
                        onEdit={handleEdit}
                        suppressQuickControl={true}
                    />
                </CardContent>
            </Card>
        </Box>
    );
}
